import React from 'react';

// Engraved line marks — thin single-weight strokes with square joins, so they
// sit with the display type rather than reading as a generic icon set.
const marks = {
  books: (
    <>
      <path d="M3.5 6.5C3.5 5.6 4.3 5 5.5 5H11v14H5.5c-1.2 0-2-.6-2-1.5V6.5Z" />
      <path d="M20.5 6.5C20.5 5.6 19.7 5 18.5 5H13v14h5.5c1.2 0 2-.6 2-1.5V6.5Z" />
      <path d="M11 5v14" opacity="0.4" />
    </>
  ),
  tap: (
    <>
      <path d="M4 8h9" />
      <path d="M4 12h5" />
      <path d="M11.5 11.5 20 15l-3.4 1.1L15.4 20l-3.9-8.5Z" />
    </>
  ),
  quiz: (
    <>
      <path d="M4 5h7v5H4zM13 5h7v5h-7zM4 14h7v5H4zM13 14h7v5h-7z" />
      <path d="m14.6 16.4 1.5 1.5 3-3.2" />
    </>
  ),
  vocab: (
    <>
      <path d="M5 4h14v16l-7-3.2L5 20V4Z" />
      <path d="M8.5 9h7M8.5 12h4" />
    </>
  ),
  audio: (
    <>
      <path d="M4 10v4M8 7v10M12 4v16M16 8v8M20 11v2" />
    </>
  ),
  sepia: (
    <>
      <path d="M12 4.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Z" />
      <path d="M12 4.5v15" />
      <path d="M12 4.5a7.5 7.5 0 0 1 0 15Z" fill="currentColor" fillOpacity="0.16" stroke="none" />
    </>
  ),
} as const;

export type FeatureMarkId = keyof typeof marks;

const FeatureMark: React.FC<{ id: FeatureMarkId; className?: string }> = ({ id, className = '' }) => (
  <svg
    viewBox="0 0 24 24"
    aria-hidden="true"
    className={`h-6 w-6 shrink-0 text-primary ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.25"
    strokeLinecap="square"
    strokeLinejoin="miter"
  >
    {marks[id]}
  </svg>
);

export default FeatureMark;
